import React from 'react';

function Reports() {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        // src="https://datauniverse-841904208.catalystserverless.com/server/CrossProjectQuery/salesjet"
        // src="https://datauniverse-841904208.catalystserverless.com/server/CrossProjectQuery/app?app=salesjet"
        src=" https://datauniverse-841904208.catalystserverless.com/server/ReportsInterface/salesjet"
        // src="https://datauniverse-841904208.catalystserverless.com/server/CrossProjectQuery/?app=salesjet"
        
        title="Cross Project Query Report"
        style={{ height: '100%', width: '100%', border: 'none' }}
      />
    </div>
  );
}

export default Reports;